module.exports = __webpack_public_path__ + "static/media/senders.d437d899.svg";